<template>
  <div class="h-screen">
    <div class="title">
      <img :src="getTitleImage()" />
    </div>
    <div class="steps">
      <div class="spacer"></div>
      <div class="step1">
        <img src="images/step1.svg" />
        <p>{{ getText('steps_text_1') }}</p>
      </div>
      <div class="next">
        <img src="images/next.svg" />
      </div>
      <div class="step2">
        <img src="images/step2.svg" />
        <p>{{ getText('steps_text_2') }}</p>
      </div>
      <div class="next">
        <img src="images/next.svg" />
      </div>
      <div class="step3">
        <img src="images/step3.svg" />
        <p>{{ getText('steps_text_3') }}</p>
      </div>
      <div class="spacer"></div>
    </div>
    <div class="start">
      <button
        class="bg-white py-5 px-40 rounded-full"
        @click="next"
      >{{ this.getText('button_start')}}</button>
    </div>
  </div>
</template>

<style scoped>
.title {
  margin-left: auto;
  margin-right: auto;
  padding-top: 24px;
  width: 490px;
  height: 320px;
}

.title img {
  width: 100%;
}

.steps {
  display: flex;
  text-align: center;
}

.spacer {
  width: 13%;
}

.step1 {
  width: 20%;
}

.step1 p {
  font-size: 34px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 350px;
}

.step1 img {
  width: 240px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 65px;
}

.step2 {
  width: 16%;
}

.step2 p {
  font-size: 34px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 30px;
}

.step2 img {
  width: 240px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 65px;
}

.step3 {
  width: 20%;
}

.step3 p {
  font-size: 34px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 350px;
}

.step3 img {
  width: 240px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 65px;
}

.next {
  width: 12%;
}

.next img {
  margin-left: auto;
  margin-right: auto;
  margin-top: 155px;
}

.start {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>

<script>
export default {
  name: "Steps",
  methods: {
    getText: function(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    getTitleImage: function() {
      return "images/jodler_" + this.$route.params.lang + ".svg";
    },

    next() {
      this.$router.push("/gender/" + this.$route.params.lang);
    }
  }
};
</script>

